<template>
	<div id="Competences-Grid" class="p-grid p-justify-between inner-content-container">
		<div class="landing-competences-cell p-col-12 p-md-12 p-lg-6 p-xl-4" v-for="competence in competenceData" :key="competence.id">
			<CompetencesCell :competence="competence" :baseUrl="baseUrl"/>
		</div>
	</div>
</template>

<script>

import CompetencesCell from './Competences-Cell.vue';
import JsonProvider from '../../../services/DataService.js';
import {configData} from '../../../services/DataService.js';

	export default {
		Name: 'CompetencesGrid',
		components: {CompetencesCell},
		data: function() {
			return {

				competenceData: [],
				baseUrl: String,
			}
		},
		
		created: async function() {
			const jsonGetter = new JsonProvider();
			this.competenceData = await jsonGetter.fetchJsonObject('competences', true);
			this.baseUrl = configData.baseUrl.data.baseUrl;
		},
	}
</script>

<style scoped>
		.landing-competences-cell {
		display: flex;
		justify-content: center;
		padding: 0;
	}

	@media (max-width: 991px) {
		.landing-competences-cell {
			max-width: 75%;
			margin: auto;
		}
	}

	@media (min-width: 768px) {
		#Competences-Grid {
			margin: auto;
			padding-bottom: 10em;
			max-width: 1000px;
		}
	}
	
	@media (max-width: 767px) {
		.landing-competences-cell {
			width: 90%;
			max-width: 90%;
		}

	#Competences-Grid {
			padding-bottom: 5em;
			margin-top: 20vh;
		}	
	}

	@media (max-width: 576px) {
		#Competences-Grid {
			margin-top: 0;
		}
	}
	
</style>

